import React from 'react';

interface IFormRowProps {
    className?: string;
    style?: React.CSSProperties;
    layout?: Array<string | number>;
}

const FormRow: React.FC<IFormRowProps> = (props) => {
    const className = `dlc-form-row ${props.className || ''}`;
    let children: Array<JSX.Element> = undefined;

    const includeSpacers = (finalChildren: Array<JSX.Element>, currentIndex: number) => {
        while (props.layout[currentIndex]?.toString()?.includes('_')) {
            const preValue = props.layout[currentIndex]?.toString()?.replace('_', '');
            let n = '1';
            if (preValue && !isNaN(Number(preValue))) {
                n = preValue;
            }
            finalChildren.push(<RowSpacer key={currentIndex} style={{ flex: `${n} ${n} 0` }} />);
            currentIndex++;
        }

        return currentIndex;
    };

    if (props.layout) {
        let layoutIndex = 0;
        children = [];

        React.Children.map(props.children, (child: React.ReactNode, index: number) => {
            layoutIndex = includeSpacers(children, layoutIndex);

            const style2 = { flex: `${props.layout[layoutIndex]} ${props.layout[layoutIndex]} 0` };
            let style: React.CSSProperties;

            if ((child as React.ReactElement).props !== undefined && (child as React.ReactElement).props.style) {
                style = { ...(child as React.ReactElement).props.style, ...style2 };
            } else {
                style = style2;
            }

            children.push(React.cloneElement(child as React.ReactElement, { key: layoutIndex, style }));
            layoutIndex++;
        });

        layoutIndex = includeSpacers(children, layoutIndex);
    }

    return (
        <div className={className} style={props.style}>
            {children || props.children}
        </div>
    );
};

FormRow.displayName = 'FormRow';

interface IRowSpacerProps {
    style: React.CSSProperties;
}

const RowSpacer: React.FC<IRowSpacerProps> = (props) => {
    const style: React.CSSProperties = {
        ...{
            display: 'inline-block',
        },
        ...props.style,
    };

    return <div style={style} />;
};

export default FormRow;



// WEBPACK FOOTER //
// ./src/components/controls/forms/common/FormRow.tsx